<core-mobile-bar [menu]="menu"></core-mobile-bar>
<div class="desktop-menu hide-on-small-only cmd-h-100">
  <core-left-sidebar [menu]="menu" (collapseClick)="onCollapseClick($event)"></core-left-sidebar>
</div>

<div class="dashboards-wrapper cmd-w-100" [ngClass]="{'expand':menuCollapsed}">
    <section class="content">
      <router-outlet></router-outlet>
    </section>
</div>